import React from 'react';
import {connect, ConnectedProps} from 'react-redux';
import FileDropWrapper from './FileDropWrapper';
import {RootState} from 'app/rootReducer';
import {Route, RouteComponentProps} from 'react-router';
import {fetchUploadedFiles, saveFiles} from './fileUploadSlice';
import {uploadedFilesRoute, UploadedFilesRoute, uploadPath} from 'app/appRoutes';
import {Col, Row} from 'reactstrap';
import PaginationBar from 'features/shared/PaginationBar';
import {GetUploadedFilesParams} from 'api';
import UploadedFileList from './UploadedFileList';
import {FileStatusEnum} from '../../interfaces/models';
import FileUploadImageModalContainer from './FileUploadImageModalContainer';
import {push} from 'connected-react-router';

type Props = ConnectedProps<typeof connector>;

class FileUploadPage extends React.Component<Props> {
    private reloadTimeout: number | undefined = undefined;
    
    async componentDidMount() {
        const {uploadedFiles} = this.props;
        if (!uploadedFiles || !uploadedFiles.length) {
            await this.loadUploadedFiles();
        }
    }

    async componentDidUpdate(prevProps: Readonly<Props>) {
        const prevPage = prevProps.match.params.page;
        const currPage = this.props.match.params.page;
        if (prevPage !== currPage) {
            await this.loadUploadedFiles();
        } else if (this.props.uploadedFiles) {
            if (this.props.uploadedFiles.filter(x => x.fileStatus === FileStatusEnum.Processing).length > 0) {
                if (!this.reloadTimeout)
                    this.reloadTimeout = window.setTimeout(async () => {
                        this.clearReloadTimeout();
                        await this.loadUploadedFiles(true);
                    }, 3000);
            } else {
                this.clearReloadTimeout();
            }
        }
    }
    
    clearReloadTimeout() {
        window.clearTimeout(this.reloadTimeout);
        this.reloadTimeout = undefined;
    }
    
    async loadUploadedFiles(silent: boolean = false) {
        const {fetchUploadedFiles, match: {params}} = this.props;
        const request: GetUploadedFilesParams = {
            page: parseInt(params.page) || 0
        };
        await fetchUploadedFiles(request, silent);
    }
    
    render() {
        const {saveFiles, isUploadingFiles, uploadedFiles, pageCount, match: {params}, push} = this.props;
        const getRoute = (pageNum: number) => uploadedFilesRoute(pageNum - 1);
        
        const saveFilesAndReload = async (files: FileList) => {
            await saveFiles(files);
            await this.loadUploadedFiles();
        }
        
        const handleCrop = (fileId: number) => {
            push(uploadedFilesRoute(params.page, fileId));
        }
        
        return <>
            <Row>
                <Col md={12} className="pb-3">
                    <h2>Upload files</h2>
                </Col>
            </Row>
            <Row>
                <Col md={12} className="pb-5">
                    <FileDropWrapper saveFiles={saveFilesAndReload} isUploadingFiles={isUploadingFiles} multiple />
                </Col>
            </Row>
            <Row>
                <Col md={12} className="pb-2">
                    <h4>File list</h4>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <UploadedFileList uploadedFiles={uploadedFiles} handleCrop={handleCrop} />
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <PaginationBar params={params} pageCount={pageCount} getRoute={getRoute} />
                </Col>
            </Row>
            {params.fileId !== undefined && <Route path={uploadPath} component={FileUploadImageModalContainer} />}
        </>;
    }
}

const mapStateToProps = (state: RootState, ownProps: RouteComponentProps<UploadedFilesRoute>) => {
    return {
        ...state.uploads,
        ...ownProps,
        isLoading: state.api.isLoading,
        isUploadingFiles: state.api.loadingProcList.indexOf('uploadFiles') > -1
    };
};
const mapDispatchToProps = {saveFiles, fetchUploadedFiles, push};
const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(FileUploadPage);